




import { Component, InjectReactive, Vue } from 'vue-property-decorator';

import { FeedTank } from '@/api';

import FeedTankVolumeChart from './components/FeedTankVolumeChart.vue';

@Component({
	components: {
		FeedTankVolumeChart,
	},
})
export default class FeedTankCharts extends Vue {
	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank;
}
